import { ClassifyIssueButtonItem } from './button-item';
import { ClassifyIssue } from './main';
import messages from './messages';

export const classifyIssueLabel = messages.classifyIssue;
export const classifyRequestLabel = messages.classifyRequest;
export { ClassifyIssue, ClassifyIssueButtonItem };
